import React from 'react';
import { useTranslation } from 'react-i18next';

import { HoldingTablet } from '@assets/images';

import PrimaryButton from '@components/atoms/Button/PrimaryButton';
import Img from '@components/atoms/Img';
import Text, { FontFamilyVariant, TextType } from '@components/Text';

import navigator from '@navigator/index';
import { NavigationUrl, URLs } from "@navigator/NavigationUrl";

import './styles.less';

const GetStartedSection = () => {
    const { t } = useTranslation();
    const goToLogin = () => {
        navigator.push(NavigationUrl.generate(URLs.login));
    }

    return (
        <div className="started-section-container">
            <div className="description-container">
                <Text
                    className="new-skills-info"
                    fontFamilyVariant={FontFamilyVariant.bold}
                    text={t('guestView.labelsAndTitles.SECTION_TITLE1')}
                    textType={TextType.display2}
                />
                <Text
                    className="new-skills-info-description"
                    textType={TextType.h8}
                    fontFamilyVariant={FontFamilyVariant.regular}
                    text={t('guestView.labelsAndTitles.SECTION_DESCRIPTION1')}
                />
                <div className="guest-button-container">
                    <PrimaryButton
                        className="guest-started-button"
                        htmlType="submit"
                        onClick={goToLogin}
                    >
                       {t('guestView.actions.GET_STARTED')}
                    </PrimaryButton>
                </div>
                <div className="holding-tablet-container">
                    <Img alt='holding-tablet' src={HoldingTablet} className="holding-tablet" />
                </div>
            </div>
        </div>
    )
}

export default GetStartedSection;

